/**
 * Custom Comparison Template
 */

import { escapeHtml, createBlockWrapper } from '../utils';
import { applyThemeOverrides } from './utils';
import type { TemplateRenderer } from './types';

export const renderCustomComparison: TemplateRenderer = (
  config,
  data,
  container,
  _onAction,
  themeOverrides
) => {
  const title = config.title as string | undefined;
  const leftLabel = (config.leftLabel as string) || 'Before';
  const rightLabel = (config.rightLabel as string) || 'After';
  const showIcons = (config.showIcons as boolean) ?? true;

  const leftItems = (data.left || data.before || []) as string[];
  const rightItems = (data.right || data.after || []) as string[];

  const wrapper = createBlockWrapper('custom-comparison');
  applyThemeOverrides(wrapper, themeOverrides);

  if (title) {
    const titleEl = document.createElement('div');
    titleEl.className = 'pms-custom-comparison-title';
    titleEl.textContent = title;
    wrapper.appendChild(titleEl);
  }

  const grid = document.createElement('div');
  grid.className = 'pms-custom-comparison-grid';

  // Left column
  const leftCol = document.createElement('div');
  leftCol.className = 'pms-custom-comparison-col pms-custom-comparison-left';
  leftCol.innerHTML = `<div class="pms-custom-comparison-header">${escapeHtml(leftLabel)}</div>`;
  const leftList = document.createElement('ul');
  leftList.className = 'pms-custom-comparison-list';
  for (const item of leftItems) {
    const li = document.createElement('li');
    li.innerHTML = showIcons
      ? `<span class="pms-comparison-icon pms-comparison-icon-negative">✗</span> ${escapeHtml(item)}`
      : escapeHtml(item);
    leftList.appendChild(li);
  }
  leftCol.appendChild(leftList);
  grid.appendChild(leftCol);

  // Right column
  const rightCol = document.createElement('div');
  rightCol.className = 'pms-custom-comparison-col pms-custom-comparison-right';
  rightCol.innerHTML = `<div class="pms-custom-comparison-header">${escapeHtml(rightLabel)}</div>`;
  const rightList = document.createElement('ul');
  rightList.className = 'pms-custom-comparison-list';
  for (const item of rightItems) {
    const li = document.createElement('li');
    li.innerHTML = showIcons
      ? `<span class="pms-comparison-icon pms-comparison-icon-positive">✓</span> ${escapeHtml(item)}`
      : escapeHtml(item);
    rightList.appendChild(li);
  }
  rightCol.appendChild(rightList);
  grid.appendChild(rightCol);

  wrapper.appendChild(grid);
  container.appendChild(wrapper);
};
